import { FORM_LOADER } from "./actionTypes";

export const formLoader = (loading) =>  ({
    type: FORM_LOADER,
    payload: loading
})